import { IStock } from '@notino/shared/definitions/custom-definitions';

import { getSupportedAttributes } from '@components/Tags/model';
import { getRenderableAttributes } from '@components/Tags/utils';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { AB_TEST_ORIGINAL_PRICE_DISCOUNT_PERCENTAGE_THRESHOLD } from '../../hooks/usePriceLogic';
import { getDiscountPercentage } from '../../hooks/usePriceLogic/utils';
import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';

import { useShouldRenderTagDiscount } from './shouldRenderTagDiscount';

export const useShouldRenderEligibleAction = () => {
  const { currentVariant } = useProductDetailContext();
  const shouldRenderTags = useShouldRenderTagDiscount(currentVariant);
  const hasVoucherDiscount = !!useResolvedVoucherDiscount();
  const { experiment_pd_action_percentage_from_rrp } = useFeatureFlags();
  const supportedAttributes = getSupportedAttributes();

  if (
    !shouldRenderTags ||
    hasVoucherDiscount ||
    currentVariant.stockAvailability.code === IStock.outOfStock
  ) {
    return false;
  }

  const attributes = getRenderableAttributes({
    attributes: currentVariant.attributes,
    supportedAttributes,
  });
  const isEligible = currentVariant?.recentMinPrice?.isActionEligible;
  const isActionOrClearance = attributes.Action || attributes.Clearance;

  if (experiment_pd_action_percentage_from_rrp && isActionOrClearance) {
    return (
      isEligible ||
      getDiscountPercentage(
        currentVariant.price.value ?? 0,
        currentVariant.originalPrice?.value ?? 0
      ) >= AB_TEST_ORIGINAL_PRICE_DISCOUNT_PERCENTAGE_THRESHOLD
    );
  }

  return Boolean(attributes.Action) && isEligible;
};
